import './bootstrap';

/*
 * app.css is emitted by webpack.mix postCss() and loaded via <link rel="preload">
 * in the Blade layout. Do not import it here — that would pull CSS into the JS
 * dependency graph and add main-thread work during bundle evaluation.
 */

import { setupTailwindWindowConfig } from './app/setupTailwindWindowConfig';
import {
    applyMaintenanceDocumentState,
    initSplashOverlay,
    isSiteUnderMaintenance,
} from './app/maintenanceAndSplash';
import { runApplication } from './app/runApplication';

setupTailwindWindowConfig();

const siteUnderMaintenance = isSiteUnderMaintenance();

if (siteUnderMaintenance) {
    applyMaintenanceDocumentState();
} else {
    initSplashOverlay();
    runApplication();
}
